var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGallery = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 45 45"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19380",
  transform: "translate(-1498 -523)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 22.5,
  r: 22.5,
  fill: "none",
  "data-name": "Ellipse 1556",
  transform: "translate(1498 523)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 15191"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M1506 531h30v30h-30z",
  "data-name": "Rectangle 6421"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13391",
  transform: "translate(1509.934 535.94)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13390"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13389"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M0 13.078c0 5.03 3.018 7.042 8.048 7.042h6.038c5.03 0 8.048-2.012 8.048-7.042V7.042c0-5.03-3.018-7.042-8.048-7.042H8.05C3.02 0 .002 2.012.002 7.042Z",
  "data-name": "Path 16502"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m3.366 14.505 3.309-3.309 1.765 1.766 4.82-4.82 5.522 5.522",
  "data-name": "Path 16503"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.934,
  cy: 0.934,
  r: 0.934,
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Ellipse 1431",
  transform: "translate(5.188 5.045)"
}))))));
export { SvgGallery as ReactComponent };
export default __webpack_public_path__ + "static/media/gallery.a70ab0f3b6de08a9e89be394c98ddf71.svg";